import Axios from 'axios'
import { backendUrl } from '../../shared/API'
import { useContext } from 'react'
import { UserContext } from '../../context api/UserContext'


const authToken = localStorage.getItem('token') ? localStorage.getItem('token') : JSON.parse(localStorage.getItem('token'))
console.log("in custom api")


export const axiosAuth = Axios.create({
  baseURL: backendUrl,
  // timeout: 5000,
  headers: {
    Authorization: "Bearer " + authToken?.substr(1, authToken.length-2),
  },
})

export const getAllData = async (url, query = {}) => {
  const limit = query.limit || 10
  const page = query.page || 1

  try {
    const response = await axiosAuth({
      method: 'GET',
      url,
      params: {
        ...query,
        limit,
        page,
      },
    })
    return response.data
  } catch (error) {
    return error.response
  }
}

export const getById = async (url, id) => {
  const response = await axiosAuth({
    method: 'GET',
    url: `${url}/${id}`,
  })
  return response.data
}

export const createDocument = async (url, data) => {
  const response = await axiosAuth({
    method: 'POST',
    url,
    data,
  })

  return response.data
}

export const updateDocumentByID = async (url, id, data) => {
  const response = await axiosAuth({
    method: 'PUT',
    url: `${url}/${id}`,
    data,
  })
  return response.data
}

export const updateDocumentWithUrl = async (url, data) => {
  const response = await axiosAuth({
    method: 'PUT',
    url: url,
    data,
  })
  return response.data
}

export const deleteDocumentById = async (url, id) => {
  const response = await axiosAuth({
    method: 'DELETE',
    url: `${url}/${id}`,
  })
  return response.data
}

export const deleteMany = async (url, data) => {

  console.log("delete Many", data)
  const response = await axiosAuth({
    method: 'PUT',
    url,
    data
  })
  return response.data
}
  